import { useNavigate } from 'react-router-dom';
import LureoButton from '@/common/LureoButton';
import { XCircleIcon, ArrowLeftIcon } from '@phosphor-icons/react';
import { Card } from '@/components/ui/card';
import { TextLink } from '@/components/ui/text-button';
import { PageTitle } from '@/components/ui/text';
import { PageFrame } from '@/components/ui/page-frame';

export default function BillingCancel() {
  const navigate = useNavigate();

  return (
    <PageFrame layout="centred" surface="own" className="bg-lureo-surface bg-linear-to-br from-lureo-neutral-subtle via-lureo-accent/10 to-lureo-brand/5">
      <Card elevation="high" padding="lg" className="w-full max-w-md rounded-lureo-radius-xl text-center">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="bg-lureo-neutral rounded-full p-6">
            <XCircleIcon className="w-16 h-16 text-lureo-ink-subtle" weight="fill" />
          </div>
        </div>

        {/* Title */}
        <PageTitle className="mb-3">
          Checkout Canceled
        </PageTitle>

        {/* Message */}
        <p className="text-lureo-ink-subtle mb-8 leading-relaxed">
          Nothing changed with your subscription. You can upgrade your plan anytime from your dashboard.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <LureoButton
            onClick={() => navigate('/dashboard')}
            variant="secondary"
            className="w-full h-12 rounded-lureo-radius-button-pill px-6"
          >
            <ArrowLeftIcon className="w-5 h-5" />
            Return to Dashboard
          </LureoButton>
        </div>

        {/* Additional info */}
        <div className="mt-8 pt-6 border-t-lureo-border-width border-lureo-line">
          <p className="text-lureo-14 text-lureo-ink-subtle leading-5">
            Changed your mind? You can always upgrade later or{' '}
            <TextLink href="mailto:team@lureo.com">
              contact support
            </TextLink>{' '}
            if you have questions.
          </p>
        </div>
      </Card>
    </PageFrame>
  );
}

